import { Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

/**
 * Customers empty state — 72px gradient disc + maxsus matn.
 */
export default function CustomersEmpty() {
  const { t } = useTranslation('owner');

  return (
    <div
      className="bl-animate-in"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 32px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          background:
            'linear-gradient(135deg, rgba(51,144,236,0.14) 0%, rgba(51,144,236,0.28) 100%)',
          border: '1px solid rgba(51,144,236,0.22)',
          color: 'var(--bl-accent, #3390ec)',
          fontSize: 28,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          boxShadow: '0 8px 24px rgba(51,144,236,0.10)',
        }}
      >
        <TeamOutlined />
      </div>

      <Text
        style={{
          fontSize: 15,
          fontWeight: 700,
          color: 'var(--bl-text-strong, #0f172a)',
          display: 'block',
          marginBottom: 6,
        }}
      >
        {t('customers.emptyTitle')}
      </Text>
      <Text
        style={{
          fontSize: 13,
          color: 'var(--bl-text-muted, #6b7280)',
          display: 'block',
          maxWidth: 280,
          lineHeight: 1.45,
        }}
      >
        {t('customers.emptyDesc')}
      </Text>
    </div>
  );
}
